console.log('swiper js loaded');
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

(function (Drupal, once) {
  Drupal.behaviors.swiperInit = {
    attach(context) {
      once('swiper', '.swiper', context).forEach((el) => {
        new Swiper(el, {
          modules: [Autoplay, Navigation, Pagination],

          slidesPerView: 1,
          loop: true,
          speed: 1400,

          autoplay: {
            delay: 500,
            disableOnInteraction: false,
          },

          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },

          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
          },
        });
      });
    },
  };
})(Drupal, once);

